import React from 'react';

import { useCheckIsProductOverlay } from 'hooks/product';

export const ConditionalProductBaseModules = ({ children }) => {
  const isProductOverlay = useCheckIsProductOverlay();
  return <>{children(isProductOverlay)}</>;
};

export const ConditionalProductAdvancedModules = ({ children }) => {
  const isProductOverlay = useCheckIsProductOverlay();
  return <>{children(isProductOverlay)}</>;
};

export const ConditionalProductEdit = ({ children }) => {
  const isProductOverlay = useCheckIsProductOverlay();
  return <>{children(isProductOverlay)}</>;
};
